module.exports = {
	"pagination": {
		"DescribeActivations": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "ActivationList"
		},
		"DescribeInstanceInformation": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "InstanceInformationList"
		},
		"ListAssociations": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "Associations"
		},
		"ListCommandInvocations": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "CommandInvocations"
		},
		"ListCommands": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "Commands"
		},
		"ListDocuments": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "DocumentIdentifiers"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/ssm-2014-11-06.paginators.json
// module id = 723
// module chunks = 0